<div class="w-full h-5 flex justify-left items-center gap-4">
    <app-tb-toggle
        class="pb-1.5"
        [checked]="isOneUser"
        (valueChange)="onChange($event)"
    ></app-tb-toggle>
    <div
        class="text-text body-1"
        *transloco="let tAddFieldContent; read: 'manage_fields.add_field_content'"
    >
        {{ tAddFieldContent(isAssignee ? 'one_user_assign' : 'one_user_add') }}
    </div>
</div>
